import { DataAccess } from "../../../dataaccess/data.access";
import { AccessLevel } from "../../../pojo/Fls";

/** One row from GET /permission/actions */
export interface PermissionDiagnosticCatalogEntry {
    name: string;
    label: string;
    requirements: string;
}

export interface PermissionDiagnosticActionsResponse {
    actions: PermissionDiagnosticCatalogEntry[];
    ingestionPointActions?: PermissionDiagnosticCatalogEntry[];
}

export class PermissionDiagnosticService {
    /** GET .../run/permission/actions.json — server PermissionRegistry catalog. */
    public static async listActions(): Promise<PermissionDiagnosticActionsResponse> {
        return DataAccess.get<PermissionDiagnosticActionsResponse>("/permission/actions.json");
    }

    public static async explain(
        action: string,
        orgId?: number,
        targetContactId?: number,
        ingestionPointId?: number,
    ): Promise<PermissionExplainResponse> {
        const params = DataAccess.params({ action, orgId, targetContactId, ingestionPointId });
        const path = `/permission/explain.json${params ? `?${params}` : ""}`;
        return DataAccess.get<PermissionExplainResponse>(path);
    }

    public static async effectiveRights(
        orgId: number,
        targetContactId?: number,
    ): Promise<PermissionEffectiveRightsResponse> {
        const params = DataAccess.params({ orgId, targetContactId });
        const path = `/permission/effective-rights.json${params ? `?${params}` : ""}`;
        return DataAccess.get<PermissionEffectiveRightsResponse>(path);
    }
}

/** Mirrors {@link com.collegenet.series25.controller.SecurityDiagnosticController.ExplainResponse} */
export interface PermissionExplainResponse {
    err_msg?: string;
    action: string;
    orgId: number | null;
    contactId: number | null;
    allowed: boolean;
    denyReason: string | null;
    statusMessages?: string[];
    trace: PermissionExplainTraceEntry[];
}

export interface PermissionExplainTraceEntry {
    layer: string;
    detail: string;
    granted: boolean;
}

export interface PermissionEffectiveRightsResponse {
    err_msg?: string;
    orgId: number;
    contactId: number;
    rights: Omit<AccessLevel, "objectId">[];
}
